import styled from 'styled-components';




const GoalCardContainer = styled.div`
  border-radius: 12px;
  position: relative;
  padding:16px;
  border: 1px solid var(--Serene-Blue-500, #92A4DA);
  background: var(--Serene-Blue-200, #E7EEF8);
  height: 164px;
  align-self: stretch;
  margin-bottom: 20px;

  .myGoalHeading{
    color:  #092F41;
    font-family: Lato;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; 
  }

  .goalText{
    width:258px;
    color: #092F41;
   font-family: Lato;
   font-size: 16px;
   font-style: normal;
   font-weight: 400;
   line-height: 20px; 
   margin-top:4px;
  }

  .goalIcon{
    position: absolute;
    top:44px;
    right:-3px;
  }

`;



const TaskContainer = styled.div`
  display: flex;
  padding: 20px;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 20px;
  align-self: stretch;
  border-radius: 12px;
  border: 0.75px solid var(--Crimson-Blush-300, #EEB3B4);
  background: var(--Crimson-Blush-500, #DA6C74);

.taskHeading{
   display:flex;
   flex-direction:column;
    gap:12px;
}

  .completionContainer{
     display: flex;
     align-items: center;
     gap: 8px;
     margin-top: 16px;
  }

  `;


const TextContainer = styled.div`
  color: ${({isTextColor})=> isTextColor ? isTextColor : '#184A61'};
  font-family: Lato;
  font-size: ${({isFontSize})=> isFontSize ? isFontSize : '16px'};
  font-style: normal;
  font-weight: ${({isFontWeight})=> isFontWeight ? isFontWeight : '400'};
  line-height: ${({isLineHeight})=> isLineHeight ? isLineHeight : '20px'};
  text-align: left;
  margin:${({isMargin})=> isMargin ? isMargin : '0'};
`;





export const CheckBoxContainer = styled.div`
    display:flex;
    align-items:center;
    .selection{
      border-radius: 4px;

    border:${({selected, disabled}) => disabled?'1px solid #FEFEFE': selected ? '1px solid #FEFEFE' : '1px solid #FEFEFE'};
    background:${({selected,disabled}) => disabled?'#EFEFEF': selected ? '#F37A65' : '#DA6C74'};
    width: 20px;
    height: 20px;
    position: relative;
    cursor: pointer;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-family: Lato;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; 
    }
    .archive-action{
    border-radius: 4px;
    border:${({selected, disabled}) => disabled?'1px solid #BDBDBD': selected ? '1px solid #F37A65' : '1px solid #7C7C7C'};
    background:${({disabled}) => disabled?'#EFEFEF': '#F8F8F8'};
    width:20px;
    height:20px;
    position:relative;
    cursor:pointer;
    >svg{
        position:absolute;
        right:2px;
        top:3px;
    }
}
`




const TaskCalendar = styled.div`
  width: 100%;
    
  .react-calendar {
    width: 100% !important;
    border: none;
    background: white;
  }

  /* Header (month + arrows) */
  .react-calendar__navigation {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    button {
      background: none;
      border: none;
      font-size: 18px;
      cursor: pointer;
    }
  }

  .react-calendar__navigation__arrow {
  display: none !important;
}


   .react-calendar__tile.future {
     background: #F8F8F8 !important;
     color: #7C7C7C !important;
     cursor: not-allowed;
   }
   .react-calendar__month-view__weekdays abbr {
     text-decoration: none !important;
     border-bottom: none !important;
     cursor: default;
   }

   .react-calendar__month-view__weekdays__weekday:hover {
     background: transparent !important;
   }


  /* Week days */
  .react-calendar__month-view__weekdays {
    text-align: center;
    font-size: 16px;
    height:36px;
    color: #BDBDBD !important;
    margin-bottom:16px;
    font-weight: 400 !important;
l   line-height: 20px !important;
  }

  /* Grid layout */
  .react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: repeat(7, 1fr);
    gap: 8px;
    height:208px;
  }

   

  /* Each day tile */
  .react-calendar__tile {
    height: 28px;
    border-radius: 4px;
    border: none;
    background: #f8f8f8;
    font-size: 16px;
    font-weight:400;
    line-height:20px;
    color: #184a61;
  }

  /* Hide outside month days */
        .react-calendar__month-view__days__day--neighboringMonth {
          opacity: 0;
          pointer-events: none;
        }
      
        .react-calendar__navigation__label {
          flex-grow: 0 !important;
        }
       
         .react-calendar__navigation {
         justify-content: center;
       }
       
       .react-calendar__navigation__arrow {
         display: none !important;
       }
       
       .react-calendar__navigation__label {
         flex-grow: 0 !important;
         font-weight: 600;
         color: #0F3D5E; /* match your design */
       }
       
       
       
         .react-calendar__navigation button {
          display: none;
         }
         
         .react-calendar__navigation__label {
           display: block !important;
         }
       
       
         .react-calendar__navigation__label {
         background: none !important;
         font-weight: 700;
         font-size: 16px;
         color: #184a61;   /* Figma dark blue */
        }
        
        .react-calendar__navigation__label span {
          color: #184a61;
        }
       
       
        .react-calendar__navigation {
         justify-content: center;
         gap: 12px;
         margin-bottom:16px !important;
       }


  /* Today (blue like Figma) */
 
  /* Selected / completed */
    .completed {
      background: #DDEEDF !important;
    }
  
    /* Not completed */
    .missed {
      background: #FDD2CB !important;
    }
  
    .react-calendar__tile.na {
    background: #DCDCDC !important;
    color: #7C7C7C !important;
    cursor: not-allowed;
  }
  
  .future {
    background-color: #F8F8F8 !important;
    color: #BDBDBD !important;
    pointer-events: none; /* ❌ no click */
  }

  .na {
    background: #DCDCDC !important;
    color: #7C7C7C !important;
    cursor: not-allowed;
  }
  ${'' /* .react-calendar__tile--now {
    background: #D3DEF2 !important;
    border: 1px solid #92A4DA !important;
    border-radius: 4px; 
    color: #184A61;
  } */}

  .react-calendar__tile--now:enabled:hover,
  .react-calendar__tile--now:enabled:focus {
    background: #D3DEF2 !important;
    ${'' /* border: 1px solid #92A4DA !important; */}
  }


    ${'' /* .react-calendar__tile.selected {
    border-radius: 4px;
    border: 1px solid var(--Serene-Blue-500, #92A4DA);
    background: var(--Serene-Blue-300, #D3DEF2) !important;
    color: #184A61;
  } */}

  
  .react-calendar__tile.selected {
  border-radius: 4px;
  ${'' /* border: 1px solid var(--Serene-Blue-500, #92A4DA); */}
  background: var(--Serene-Blue-300, #D3DEF2) !important;
  color: #184A61;
}
  
  /* Ensure selected overrides completed/missed */
  .react-calendar__tile.completed.selected,
  .react-calendar__tile.missed.selected {
    background: var(--Serene-Blue-300, #D3DEF2) !important;
    ${'' /* border: 1px solid var(--Serene-Blue-500, #92A4DA); */}
  }

`;





const FeelingCard = styled.div`
  cursor: pointer;
  text-align: center;
  padding: 6px;
  border-radius: 4px;
  background: transparent;
  min-width:100px;
  ${'' /* border: 1px solid transparent; */}

  &.active {
    background: var(--Green-Serenity-100, #F1F8F2);
    ${'' /* border: 2px solid #75B084; */}
  }

  .emoji {
    font-size: 24px;
  }

  .label {
    margin-top: 4px;
    font-family: Lato;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px; 
    color: var(--Font-Color-on-Light-theme-500, #184A61);
    text-align: center;
  }
`;



const DateWrapper = styled.div`
display: flex;
align-items: flex-start;
gap: 10px;


.date{
    color: #184A61;
font-family: Lato;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 16px; 
padding: 8px;
background:#EFEFEF;

}
`;


const JournalContainer = styled.div`
   display: flex;
   ${'' /* margin-top:12px; */}
   width:764px;
   flex-direction: column;
   padding: 16px;
   flex-direction: column;
   justify-content: center;
   align-items: flex-start;
   gap: 20px;
   ${'' /* align-self: stretch; */}
   border-radius: 12px;
   border: 1px solid var(--Bg-Color-for-Light-theme-300, #DCDCDC);
   background: var(--Bg-Color-for-Light-theme-600, #FEFEFE);


   .journalContent{
         display:flex;
         gap:20px;

         .aboutext{
          margin-top:8px;
         }

    }


    .feelingIcon{
      width: 40px;
      height: 40px;
      align-items: center;
      display: flex;
      justify-content: center;
      margin: auto;
    }

`;



const DateContainer = styled.div`
  display: flex;
  width:125px;
  height:32px;
  padding: 8px;
  color: var(--Font-Color-on-Light-theme-500, #184A61);
  font-family: Lato;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 133.333% */
  justify-content: center;
  align-items: center;
  gap: 10px;
  background: var(--Bg-Color-for-Light-theme-400, #EFEFEF);
  `;





const NoJournalContainer = styled.div`
  display: flex;
  height: 136px;
  padding: 16px;
  width:764px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 20px;
  border-radius: 12px;
  background: var(--Serene-Blue-100, #F2F5FB);

  .plusIcon{
    display: flex;
    width: 40px;
    margin-top:20px;
    height: 40px;
    padding: 8px 12px;
    justify-content: center;
    align-items: center;
    cursor:pointer;
    gap: 8px;
    border-radius: 24px;
    background: #FFF;
  }
  `;
  

export {GoalCardContainer, TaskContainer, NoJournalContainer,  DateContainer, TextContainer, TaskCalendar, FeelingCard, DateWrapper, JournalContainer};
